import React from 'react'
import { useSelector } from 'react-redux'
import * as DateTimeProvider from '@classic/Foundation/DateTimeProvider'
import { StructuredSearchResult } from '@core/Data/StructuredSearch/StructuredSearchResult'
import {
  StructuredSearchResultStyled,
  NoResultsStyled,
  StructuredSearchFixedOddsLabelStyled,
  StructuredSearchResultInfoHeaderStyled,
} from './StructuredSearchResults.styles'
import { getRedirectUrl } from './utils'
import { StructuredSearchResultComponent } from './StructuredSearchResult'
import { Icon } from '@mobi/component-library/Common/Icon'
import { colors } from '@core/Settings'
import { StructuredSearchTextLabel } from './StructuredSearchTextLabel'
import { StructuredSearchTextLabelFontSize } from './StructuredSearchTextLabelStyled.styles'
import { appHistory } from '@core/Utils/routing/history'
import { selectSearchResults } from '../Store/selectors'

function handleClick(searchResult: StructuredSearchResult) {
  const url = getRedirectUrl(searchResult)
  appHistory.push(url)
}

export const StructuredSearchResults = (): JSX.Element | null => {
  const { results } = useSelector(selectSearchResults)
  const currentDateMilli = DateTimeProvider.now()

  if (!results || results.length === 0) {
    return <NoResults />
  }

  const mappedResults = results.map(result => (
    <StructuredSearchResultStyled
      key={result.id}
      onClick={() => handleClick(result)}
      data-tid-structured-search-result={result.id}
    >
      <StructuredSearchResultComponent result={result} currentDateMilli={currentDateMilli} />
    </StructuredSearchResultStyled>
  ))

  return (
    <div data-tid-structured-search-results=''>
      <StructuredSearchResultInfoHeaderStyled>
        <StructuredSearchFixedOddsLabelStyled>Fixed</StructuredSearchFixedOddsLabelStyled>
      </StructuredSearchResultInfoHeaderStyled>
      {mappedResults}
    </div>
  )
}

export const NoResults = (): JSX.Element => {
  return (
    <NoResultsStyled>
      <Icon type='warningCircled' size='6rem' color={colors.structuredSearch.initialText} />
      <StructuredSearchTextLabel size={StructuredSearchTextLabelFontSize.Large}>
        No Results Found
      </StructuredSearchTextLabel>
      <StructuredSearchTextLabel size={StructuredSearchTextLabelFontSize.Small}>
        Try making your criteria less specific
      </StructuredSearchTextLabel>
    </NoResultsStyled>
  )
}
